import { Injectable } from '@angular/core';
import { HttpServices } from 'src/app/shared/services/http-service.service';
import { AdditionalWorkDTO } from '../models/additional-work.model';
import { AdminResponseDto, UserResponseDto } from '../models/adminResponseDto';

@Injectable({
  providedIn: 'root'
})
export class AdditionalWorkService {

  constructor(private http: HttpServices) { }

  public addAdditionalWork(additionalWorkDTO: AdditionalWorkDTO) {
    return this.http.post('AdditionalWork/AddAdditionalWork', additionalWorkDTO);
  }

  public setUserResponse(responseResult: UserResponseDto) {
    return this.http.post('AdditionalWork/setUserResponse', responseResult);


  }
  getAdditionalWork(id) {
    return this.http.get('AdditionalWork/GetAdditionalWork/' + id);
  }
  public adminReviewRequest(adminResponseDto: AdminResponseDto) {
    return this.http.post('AdditionalWork/AdminReviewRequest/', adminResponseDto);
  }
}
